/* eslint-disable max-len */
const ThumbsUpSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M13.067 16h-.02c-.636-.007-1.274-.007-1.911-.007h-.973c-.649 0-1.298 0-1.95-.008a3.014 3.014 0 01-1.05-.222c-.57-.221-.894-.715-.892-1.357l.001-2.408c0-1.333 0-2.668.012-4.002.002-.363.236-.703.436-.882.774-.705 1.615-1.584 1.967-2.769.097-.33.135-.695.174-1.08C8.94 2.5 9.44 2 10.105 2c.262 0 .523.078.78.23.514.308.858.792 1.047 1.481.304 1.095.149 2.158-.022 3.07v.003c-.04.212.121.41.34.41h2.222c.382 0 .931.048 1.27.456.245.298.316.7.211 1.232-.318 1.633-.707 3.28-1.08 4.814-.116.478-.31.921-.495 1.35l-.08.184c-.213.498-.65.77-1.231.77zm-9.527-.16h-.204c-.734 0-1.336-.6-1.336-1.332V8.573c0-.732.602-1.331 1.336-1.331h.204c.735 0 1.336.6 1.336 1.331v5.934c.002.733-.6 1.333-1.336 1.333z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default ThumbsUpSvg;
